import routes from '@modules/stripe/stripe-person/stripe-person-routes';
import store from '@modules/stripe/stripe-person/stripe-person-store';

export default {
  routes,
  store,
};
